export const gearedMotor_rightAngle = [
    {
        ratio: 6.3,
        frequency: 50,
        models: {
            "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        }
    },
    {
        ratio: 6.3,
        frequency: 60,
        models: {
            "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        }
    },
    {
        ratio: 7.1,
        frequency: 50,
        models: {
            "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 7.1,
        frequency: 60,
        models: {
            "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 8,
        frequency: 50,
        models: {
            "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 8,
        frequency: 60,
        models: {
            "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 9,
        frequency: 50,
        models: {
            "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 9,
        frequency: 60,
        models: {
            "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 10,
        frequency: 50,
        models: {
            "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 10,
        frequency: 60,
        models: {
            "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 11.2,
        frequency: 50,
        models: {
            "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 11.2,
        frequency: 60,
        models: {
            "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 12.5,
        frequency: 50,
        models: {
            "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 12.5,
        frequency: 60,
        models: {
            "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 14,
        frequency: 50,
        models: {
            "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 14,
        frequency: 60,
        models: {
            "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 16,
        frequency: 50,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9045,
        },
    },
    {
        ratio: 16,
        frequency: 60,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 18,
        frequency: 50,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9045,
        },
    },
    {
        ratio: 18,
        frequency: 60,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9045,
        },
    },
    {
        ratio: 20,
        frequency: 50,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9050,
        },
    },
    {
        ratio: 20,
        frequency: 60,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9045,
        },
    },
    {
        ratio: 22.4,
        frequency: 50,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9050,
        },
    },
    {
        ratio: 22.4,
        frequency: 60,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9045,
        },
    },
    {
        ratio: 25,
        frequency: 50,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9055,
        },
    },
    {
        ratio: 25,
        frequency: 60,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9055,
        },
    },
    {
        ratio: 28,
        frequency: 50,
        models: {
            "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 28,
        frequency: 60,
        models: {
            "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9040, "55": 9055,
        },
    },
    {
        ratio: 31.5,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 31.5,
        frequency: 60,
        models: {
            "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 35.5,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9045, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 35.5,
        frequency: 60,
        models: {
            "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 40,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9040, "30": 9040, "37": 9045, "45": 9050, "55": 9055,
        },
    },
    {
        ratio: 40,
        frequency: 60,
        models: {
            "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 45,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9040, "30": 9045, "37": 9050, "45": 9055, "55": 9060,
        },
    },
    {
        ratio: 45,
        frequency: 60,
        models: {
            "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9040, "37": 9045, "45": 9050, "55": 9055,
        },
    },
    {
        ratio: 50,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9035, "22": 9045, "30": 9045, "37": 9050, "45": 9055, "55": 9060,
        },
    },
    {
        ratio: 50,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9045, "37": 9045, "45": 9050, "55": 9055,
        },
    },
    {
        ratio: 56,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9035, "22": 9045, "30": 9050, "37": 9055, "45": 9060, "55": 9065,
        },
    },
    {
        ratio: 56,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9045, "37": 9050, "45": 9055, "55": 9060,
        },
    },
    {
        ratio: 63,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9040, "18.5": 9040, "22": 9050, "30": 9050, "37": 9055, "45": 9060, "55": 9065,
        },
    },
    {
        ratio: 63,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9040, "22": 9040, "30": 9050, "37": 9050, "45": 9055, "55": 9065,
        },
    },
    {
        ratio: 71,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9040, "18.5": 9045, "22": 9050, "30": 9055, "37": 9060, "45": 9065, "55": 9070,
        },
    },
    {
        ratio: 71,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9040, "22": 9045, "30": 9050, "37": 9055, "45": 9060, "55": 9065,
        },
    },
    {
        ratio: 80,
        frequency: 50,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9045, "18.5": 9045, "22": 9055, "30": 9055, "37": 9065, "45": 9065, "55": 9075,
        },
    },
    {
        ratio: 80,
        frequency: 60,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9035, "18.5": 9040, "22": 9045, "30": 9055, "37": 9055, "45": 9065, "55": 9070,
        },
    },
    {
        ratio: 90,
        frequency: 50,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9045, "18.5": 9050, "22": 9055, "30": 9065, "37": 9065, "45": 9070, "55": 9075,
        },
    },
    {
        ratio: 90,
        frequency: 60,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9040, "18.5": 9045, "22": 9045, "30": 9055, "37": 9065, "45": 9065, "55": 9070,
        },
    },
    {
        ratio: 100,
        frequency: 50,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9040, "15": 9045, "18.5": 9050, "22": 9060, "30": 9065, "37": 9070, "45": 9070, "55": 9080,
        },
    },
    {
        ratio: 100,
        frequency: 50,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9040, "15": 9040, "18.5": 9045, "22": 9050, "30": 9060, "37": 9070, "45": 9070, "55": 9070,
        },
    },
    {
        ratio: 112,
        frequency: 50,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9040, "15": 9050, "18.5": 9055, "22": 9060, "30": 9065, "37": 9070, "45": 9075, "55": 9080,
        },
    },
    {
        ratio: 112,
        frequency: 60,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9040, "15": 9045, "18.5": 9050, "22": 9055, "30": 9060, "37": 9070, "45": 9070, "55": 9075,
        },
    },
    {
        ratio: 125,
        frequency: 50,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9045, "15": 9050, "18.5": 9055, "22": 9060, "30": 9065, "37": 9070, "45": 9075, "55": 9080,
        },
    },
    {
        ratio: 125,
        frequency: 60,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9040, "15": 9045, "18.5": 9050, "22": 9055, "30": 9060, "37": 9070, "45": 9070, "55": 9075,
        },
    },
    {
        ratio: 140,
        frequency: 50,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9045, "15": 9055, "18.5": 9065, "22": 9065, "30": 9070, "37": 9075, "45": 9075, "55": 9085,
        },
    },
    {
        ratio: 140,
        frequency: 60,
        models: {
            "5.5": 9040, "7.5": 9040, "11": 9045, "15": 9050, "18.5": 9055, "22": 9060, "30": 9065, "37": 9070, "45": 9075, "55": 9075,
        },
    },
    {
        ratio: 160,
        frequency: 50,
        models: {
            "5.5": 9045, "7.5": 9045, "11": 9045, "15": 9055, "18.5": 9065, "22": 9065, "30": 9075, "37": 9075, "45": 9080, "55": 9085,
        },
    },
    {
        ratio: 160,
        frequency: 60,
        models: {
            "5.5": 9045, "7.5": 9045, "11": 9045, "15": 9055, "18.5": 9055, "22": 9065, "30": 9065, "37": 9075, "45": 9075, "55": 9085,
        },
    },
    {
        ratio: 180,
        frequency: 50,
        models: {
            "5.5": 9045, "7.5": 9045, "11": 9055, "15": 9060, "18.5": 9065, "22": 9070, "30": 9075, "37": 9080, "45": 9085,
        },
    },
    {
        ratio: 180,
        frequency: 60,
        models: {
            "5.5": 9045, "7.5": 9045, "11": 9045, "15": 9055, "18.5": 9060, "22": 9075, "30": 9070, "37": 9075, "45": 9080, "55": 9085,
        },
    },
    {
        ratio: 200,
        frequency: 50,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9055, "15": 9060, "18.5": 9070, "22": 9070, "30": 9080, "37": 9080, "45": 9085,
        },
    },
    {
        ratio: 200,
        frequency: 60,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9050, "15": 9060, "18.5": 9060, "22": 9070, "30": 9070, "37": 9080, "45": 9080,
        },
    },
    {
        ratio: 224,
        frequency: 50,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9055, "15": 9065, "18.5": 9070, "22": 9070, "30": 9080, "37": 9085,
        },
    },
    {
        ratio: 224,
        frequency: 60,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9055, "15": 9060, "18.5": 9065, "22": 9070, "30": 9075, "37": 9080, "45": 9085,
        },
    },
    {
        ratio: 250,
        frequency: 50,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9060, "15": 9065, "18.5": 9070, "22": 9075, "30": 9080, "37": 9085,
        },
    },
    {
        ratio: 250,
        frequency: 60,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9055, "15": 9060, "18.5": 9065, "22": 9070, "30": 9075, "37": 9085, "45": 9085,
        },
    },
    {
        ratio: 280,
        frequency: 50,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9065, "15": 9070, "18.5": 9075, "22": 9075, "30": 9085,
        },
    },
    {
        ratio: 280,
        frequency: 60,
        models: {
            "5.5": 9050, "7.5": 9050, "11": 9060, "15": 9065, "18.5": 9070, "22": 9075, "30": 9080, "37": 9085,
        },
    },
    {
        ratio: 315,
        frequency: 50,
        models: {
            "5.5": 9050, "7.5": 9055, "11": 9065, "15": 9075, "18.5": 9075, "22": 9080, "30": 9085,
        },
    },
    {
        ratio: 315,
        frequency: 60,
        models: {
            "5.5": 9050, "7.5": 9055, "11": 9060, "15": 9065, "18.5": 9075, "22": 9075, "30": 9085, "37": 9085,
        },
    },
    {
        ratio: 355,
        frequency: 50,
        models: {
            "5.5": 9055, "7.5": 9060, "11": 9070, "15": 9075, "18.5": 9080, "22": 9085,
        },
    },
    {
        ratio: 355,
        frequency: 60,
        models: {
            "5.5": 9050, "7.5": 9055, "11": 9065, "15": 9070, "18.5": 9075, "22": 9080, "30": 9085,
        },
    },
    {
        ratio: 400,
        frequency: 50,
        models: {
            "5.5": 9055, "7.5": 9065, "11": 9075, "15": 9075, "18.5": 9085, "22": 9085,
        },
    },
    {
        ratio: 400,
        frequency: 60,
        models: {
            "5.5": 9055, "7.5": 9055, "11": 9065, "15": 9075, "18.5": 9075, "22": 9085,
        },
    },
    {
        ratio: 450,
        frequency: 50,
        models: {
            "5.5": 9055, "7.5": 9065, "11": 9075, "15": 9085, "18.5": 9085,
        },
    },
    {
        ratio: 450,
        frequency: 60,
        models: {
            "5.5": 9055, "7.5": 9065, "11": 9075, "15": 9075, "18.5": 9085, "22": 9085
        },
    },
]



export const gearedMotor_parallel = [
    {
        ratio: 6.3,
        frequency: 50,
        models: {
            "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9025, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 6.3,
        frequency: 60,
        models: {
            "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "55": 9040,
        },
    },
    {
        ratio: 7.1,
        frequency: 50,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9040, "55": 9040,
        },
    },
    {
        ratio: 7.1,
        frequency: 60,
        models: {
            "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "55": 9040,
        },
    },
    {
        ratio: 8,
        frequency: 50,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 8,
        frequency: 60,
        models: {
            "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 9,
        frequency: 50,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 9,
        frequency: 60,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 10,
        frequency: 50,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 10,
        frequency: 60,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 11.2,
        frequency: 50,
        models: {
            "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 11.2,
        frequency: 60,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 12.5,
        frequency: 50,
        models: {
            "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 12.5,
        frequency: 60,
        models: {
            "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 14,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9025, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 14,
        frequency: 60,
        models: {
            "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9040,
        },
    },
    {
        ratio: 16,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9025, "30": 9025, "37": 9030, "45": 9035, "55": 9045,
        },
    },
    {
        ratio: 16,
        frequency: 60,
        models: {
            "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9015, "30": 9025, "37": 9030, "45": 9035, "55": 9045,
        },
    },
    {
        ratio: 18,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9025, "22": 9025, "30": 9030, "37": 9035, "45": 9035, "55": 9045,
        },
    },
    {
        ratio: 18,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9015, "22": 9025, "30": 9030, "37": 9030, "45": 9035, "55": 9045,
        },
    },
    {
        ratio: 20,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9025, "22": 9025, "30": 9030, "37": 9035, "45": 9035, "55": 9045,
        },
    },
    {
        ratio: 20,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9025, "22": 9025, "30": 9030, "37": 9035, "45": 9035, "55": 9045,
        },
    },
    {
        ratio: 22.4,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9025, "18.5": 9025, "22": 9025, "30": 9035, "37": 9035, "45": 9045, "55": 9045,
        },
    },
    {
        ratio: 22.4,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9025, "22": 9025, "30": 9035, "37": 9035, "45": 9045, "55": 9045,
        },
    },
    {
        ratio: 25,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9025, "18.5": 9025, "22": 9025, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 25,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9015, "18.5": 9025, "22": 9025, "30": 9035, "37": 9035, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 28,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9025, "18.5": 9025, "22": 9030, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 28,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9025, "18.5": 9025, "22": 9025, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 31.5,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9025, "18.5": 9030, "22": 9030, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 31.5,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9015, "15": 9025, "18.5": 9025, "22": 9030, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 35.5,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9025, "15": 9030, "18.5": 9030, "22": 9030, "30": 9035, "37": 9045, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 35.5,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9025, "15": 9025, "18.5": 9030, "22": 9030, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 40,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9025, "15": 9030, "18.5": 9030, "22": 9035, "30": 9040, "37": 9045, "45": 9050, "55": 9055,
        },
    },
    {
        ratio: 40,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9025, "15": 9025, "18.5": 9030, "22": 9030, "30": 9035, "37": 9040, "45": 9045, "55": 9055,
        },
    },
    {
        ratio: 45,
        frequency: 50,
        models: {
            "5.5": 9015, "7.5": 9025, "11": 9025, "15": 9030, "18.5": 9035, "22": 9035, "30": 9045, "37": 9050, "45": 9055, "55": 9055,
        },
    },
    {
        ratio: 45,
        frequency: 60,
        models: {
            "5.5": 9015, "7.5": 9015, "11": 9025, "15": 9030, "18.5": 9030, "22": 9030, "30": 9040, "37": 9045, "45": 9050, "55": 9055,
        },
    },
    {
        ratio: 50,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9040, "30": 9045, "37": 9050, "45": 9055, "55": 9060,
        },
    },
    {
        ratio: 50,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9030, "22": 9035, "30": 9040, "37": 9045, "45": 9050, "55": 9055,
        },
    },
    {
        ratio: 56,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9035, "22": 9040, "30": 9050, "37": 9055, "45": 9060, "55": 9065,
        },
    },
    {
        ratio: 56,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9035, "30": 9045, "37": 9050, "45": 9055, "55": 9060,
        },
    },
    {
        ratio: 63,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9040, "22": 9045, "30": 9050, "37": 9055, "45": 9060, "55": 9065,
        },
    },
    {
        ratio: 63,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9030, "18.5": 9035, "22": 9040, "30": 9045, "37": 9050, "45": 9055, "55": 9060,
        },
    },
    {
        ratio: 71,
        frequency: 50,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9045, "22": 9045, "30": 9055, "37": 9060, "45": 9065, "55": 9065,
        },
    },
    {
        ratio: 71,
        frequency: 60,
        models: {
            "5.5": 9030, "7.5": 9030, "11": 9030, "15": 9035, "18.5": 9035, "22": 9045, "30": 9050, "37": 9055, "45": 9060, "55": 9065,
        },
    },
    {
        ratio: 80,
        frequency: 50,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9045, "18.5": 9045, "22": 9055, "30": 9055, "37": 9065, "45": 9065, "55": 9075,
        },
    },
    {
        ratio: 80,
        frequency: 60,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9035, "18.5": 9045, "22": 9045, "30": 9055, "37": 9055, "45": 9065, "55": 9065,
        },
    },
    {
        ratio: 90,
        frequency: 50,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9045, "18.5": 9045, "22": 9055, "30": 9065, "37": 9065, "45": 9075, "55": 9075,
        },
    },
    {
        ratio: 90,
        frequency: 60,
        models: {
            "5.5": 9035, "7.5": 9035, "11": 9035, "15": 9035, "18.5": 9045, "22": 9045, "30": 9055, "37": 9065, "45": 9065, "55": 9075,
        },
    },
];

export const gearedMotor_gearWeight_parallel = {
    "9015": 125,
    "9025": 175,
    "9030": 235,
    "9035": 260,
    "9040": 340,
    "9045": 410,
    "9050": 490,
    "9055": 555,
    "9060": 730,
    "9065": 885,
    "9070": 1030,
    "9075": 1255,
    "9080": 1460,
    "9085": 1730,
}

export const gearedMotor_gearWeight_rightAngle = {
    "9030": 255,
    "9035": 275,
    "9040": 365,
    "9045": 435,
    "9050": 500,
    "9055": 560,
    "9060": 710,
    "9065": 865,
    "9070": 1000,
    "9075": 1220,
    "9080": 1420,
    "9085": 1680,
}

export const gearedMotor_motorWeight_parallel = {
    "5.5": 64,
    "7.5": 85,
    "11": 107,
    "15": 186,
    "18.5": 275,
    "22": 275,
    "30": 297,
    "37": 335,
    "45": 335,
    "55": 335,
};

export const gearedMotor_motorWeight_rightAngle = {
    "5.5": 62,
    "7.5": 85,
    "11": 107,
    "15": 186,
    "18.5": 291,
    "22": 291,
    "30": 313,
    "37": 335,
    "45": 335,
    "55": 335,
}